import {useMemberStore} from '~/store/member'

/**
 * 로그인 필요한 페이지 체크하는 middleware
 * @param to
 */
export default defineNuxtRouteMiddleware(() => {
  const memberStore = useMemberStore()

  // 로그인 되어있지 않은 사용자가 접근하려고 할 때
  if (!memberStore.isAuthenticated) {
    // return navigateTo('/login')
    // alert 이후 이전페이지로 이동
    alert('로그인이 필요한 페이지입니다.')
    return navigateBack()
  }
})
